if (!customElements.get("variant-selects-new")) {
  class VariantSelectsNew extends HTMLElement {
    constructor() {
      super();
      this.gender = null;
      this.country = null;
      this.optionLabels = this.querySelectorAll(".new-option-label");
      this.variantSelects = document.querySelector("variant-selects");
      this.newOptions = this.querySelector(".new-variant-selects-options");
    }

    connectedCallback() {
      this.newOptions.querySelectorAll("input").forEach((input) => {
        input.addEventListener("change", (e) => {
          this.togglePreorderNotice(e.target);
          this.handleValueChange(e.target.value);
        });
      });

      // Simple sizes (socks, laces) render without the gender/region header and
      // with every value already .active, so there is nothing to toggle.
      if (this.hasAttribute("data-simple")) return;

      // These used to read .value straight off the :checked radio. When the markup failed
      // to pre-select a region, that was null, connectedCallback threw, and none of the
      // listeners below were ever attached -- so the picker could not recover from the bad
      // state it had been rendered in. Fall back to the first option offered and select it.
      const genderInput =
        this.querySelector(".variant-selects-gender input:checked") ||
        this.querySelector(".variant-selects-gender input");
      const countryInput =
        this.querySelector(".variant-selects-country input:checked") ||
        this.querySelector(".variant-selects-country input");
      if (!genderInput || !countryInput) return;

      genderInput.checked = true;
      countryInput.checked = true;
      this.gender = genderInput.value;
      this.country = countryInput.value;

      this.openGenderOfCheckedSize();
      this.changeSizeForCountrySelect(this.country);

      this.querySelectorAll(".variant-selects-gender input").forEach(
        (input) => {
          input.addEventListener("change", (e) => {
            this.gender = e.target.value;
            this.changeSizeForGenderSelect(this.gender);
          });
        }
      );

      this.querySelectorAll(".variant-selects-country input").forEach(
        (input) => {
          input.addEventListener("change", (e) => {
            this.country = e.target.value;
            this.changeSizeForCountrySelect(this.country);
          });
        }
      );

      // "Notify me" opens Klaviyo's modal for the selected size. If that size is
      // hidden under the current gender tab (e.g. kids 2Y while on Women), switch
      // back to its tab so the size the modal shows is the one highlighted here.
      document.addEventListener("click", (e) => {
        if (!e.target.closest(".klaviyo-bis-trigger")) return;
        this.openGenderOfCheckedSize();
        this.changeSizeForCountrySelect(this.country);
      });
    }

    disconnectedCallback() {}

    // The pre-order notice belongs to the selected size. global.js also syncs it from the
    // section it refetches, but that is a network round trip: if it is slow or fails, the
    // notice would never appear. The size tiles already carry the pre-order marker, so flip
    // visibility here straight away and let the refetch correct the date.
    togglePreorderNotice(input) {
      const grupa = document.querySelector(".new-variant-selects-preorder");
      if (!grupa || !input?.id) return;
      const label = this.newOptions.querySelector(
        `label[for="${CSS.escape(input.id)}"]`
      );
      grupa.toggleAttribute("hidden", !label?.querySelector("[preorder-option]"));
    }

    changeSizeForCountrySelect(code) {
      this.optionLabels.forEach((label) => {
        label
          .querySelectorAll(".active")
          .forEach((activeItem) => activeItem.classList.remove("active"));

        if (this.country == "EU") {
          label.querySelector(`[data-code="EU"]`)?.classList.add("active");
        } else if (this.country == "UK") {
          label.querySelector(`[data-code="UK"]`)?.classList.add("active");
        } else {
          label
            .querySelector(`[data-code="US-${this.gender}"]`)
            ?.classList.add("active");
        }
      });
    }

    changeSizeForGenderSelect(gender) {
      if (
        this.country == "US" ||
        (this.country != "EU" && this.country != "UK")
      ) {
        this.optionLabels.forEach((label) => {
          label
            .querySelectorAll(".active")
            .forEach((activeItem) => activeItem.classList.remove("active"));
          label
            .querySelector(`[data-code="US-${gender}"]`)
            ?.classList.add("active");
        });
      }
    }

    // Open the gender tab that lists the selected size (e.g. Kids for 2Y): on load
    // with ?variant= (the tab always renders as Women) and on "Notify me".
    openGenderOfCheckedSize() {
      const checked = this.newOptions.querySelector("input:checked");
      const label = checked && this.newOptions.querySelector(`label[for="${CSS.escape(checked.id)}"]`);
      if (!label || label.querySelector(`[data-code="US-${this.gender}"]`)) return;

      const gender = label.querySelector('[data-code^="US-"]')?.dataset.code.replace("US-", "");
      const genderInput = gender && this.querySelector(`.variant-selects-gender input[value="${gender}"]`);
      if (!genderInput) return;

      genderInput.checked = true;
      this.gender = gender;
    }

    handleValueChange(e) {
      const oldOption = this.variantSelects.querySelector(
        `option[value="${e}"]`
      );
      if (oldOption) {
        oldOption.selected = true;
        this.variantSelects
          .querySelector("select")
          .dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  customElements.define("variant-selects-new", VariantSelectsNew);
}
